import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useFormContext } from "react-hook-form";

type ControlledInputProps = React.ComponentProps<"input"> & {
  name: string;
  label?: string;
  noLabel?: boolean;
  placeholder: string;
  className?: string;
  labelClassName?: string;
  containerClassName?: string;
};

export default function ControlledInput({
  name,
  label,
  noLabel = false,
  placeholder,
  className,
  labelClassName,
  containerClassName,
  ...props
}: ControlledInputProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={containerClassName}>
          {!noLabel && (
            <FormLabel className={labelClassName}>{label}</FormLabel>
          )}
          <FormControl>
            <Input
              placeholder={placeholder}
              className={className}
              {...field}
              {...props}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
